import { useEffect } from 'react'
import { Outlet, useNavigation } from 'react-router-dom'

import { BackdropLoading } from '@/shared/components/BackdropLoading/BackdropLoading'
import { useAppDispatch } from '@/shared/store'
import { useTheme } from '@mui/material'

import { StyledContainer } from './StyledSubscriptionPage'
import { setupSubscription } from './thunks/setupSubscription'

export type SubscriptionPageProps = {
  //
}

export const SubscriptionPage: React.FC<SubscriptionPageProps> = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setupSubscription())
  }, [dispatch])

  return (
    <StyledContainer>
      <div style={{ width: '100%', height: '100%', backgroundColor: theme.palette.background.paper }}>
        <Outlet />
      </div>
      <BackdropLoading open={navigation.state === 'loading'} />
    </StyledContainer>
  )
}

